import Flex from "../../../components/common/Flex";
import ForgotPasswordForm from "../../../components/auth/ForgotPasswordForm";

const ForgotPassword = () => {
	return (
		<>
			<Flex justifyContent="center" alignItems="center" className="mb-2">
				<h5 className="font-weight-bold">Forgot Password</h5>
			</Flex>
			<Flex justifyContent="center" alignItems="center" className="mb-2">
				<p className="text-center">
					Enter the email associated with your account and we'll send an email
					with instructions to reset your password
				</p>
			</Flex>
			<ForgotPasswordForm />
		</>
	);
};

export default ForgotPassword;
